import { Form, Input, Button, Flex } from 'antd';
import { spacing, iconColor, coreBrandColors, textStandard, fontSize } from '../../theming';
import getInputRules, { inputType } from '../../utils/getInputRules';

function MainTab({ handler, handleBack, classes, t }) {
    return (
        <>
            <h3
                style={{
                    marginBottom: spacing[5],
                }}
            >
                {t('title')}
            </h3>
            <div className={classes.content}>
                <p className={classes.instruction}>{t('sub')}</p>
                <Form onFinish={handler}>
                    <Form.Item
                        name="email"
                        rules={getInputRules(
                            t,
                            inputType.EMAIL,
                            t('form.errors.email'),
                            t('form.errors.email-invalid')
                        )}
                    >
                        <Input
                            className={classes['input-login']}
                            prefix={
                                <i
                                    className="fi-rr-envelope"
                                    style={{ color: iconColor.signin, fontSize: '18px', marginRight: '12px' }}
                                />
                            }
                            placeholder="johan_dou@gmail.com"
                            size="large"
                            style={{
                                padding: `${spacing[1]} ${spacing[3]}`,
                            }}
                        />
                    </Form.Item>
                    <Flex vertical justify="center" align="center" gap={spacing[6]}>
                        <Button className={classes.signin} htmlType="submit" type="primary" size="large">
                            {t('buttons.send')}
                        </Button>
                        <Button
                            htmlType="button"
                            className={classes['return-button']}
                            type="link"
                            size="middle"
                            onClick={handleBack}
                            icon={
                                <i
                                    className="fi-rr-arrow-left"
                                    style={{ position: 'relative', top: 2, right: 5, fontSize: fontSize.lg }}
                                />
                            }
                        >
                            {t('buttons.back')}
                        </Button>
                    </Flex>
                </Form>
            </div>
        </>
    );
}

export default MainTab;
